<template>
  <div class="olympiad__register">
    <p>до начала олимпиады осталось</p>
    <div class="olympiad__timer">
      <div class="olympiad__timer_item">
        <p>{{ countdown.days }}</p>
        <span>{{ countdown.daysText }}</span>
      </div>
      <div class="olympiad__timer_divider" />
      <div class="olympiad__timer_item">
        <p>{{ countdown.hours }}</p>
        <span>{{ countdown.hoursText }}</span>
      </div>
      <div class="olympiad__timer_divider" />
      <div class="olympiad__timer_item">
        <p>{{ countdown.minutes }}</p>
        <span>{{ countdown.minutesText }}</span>
      </div>
      <div class="olympiad__timer_divider" />
      <div class="olympiad__timer_item">
        <p>{{ countdown.seconds }}</p>
        <span>{{ countdown.secondsText }}</span>
      </div>
    </div>
    <button
      :class="[
        'olympiad__register--btn',
        {'olympiad__register--btn-disabled': haveUser}
      ]"
      :disabled="olympiadHasEnded"
      @click="!olympiadHasEnded ? $emit('openRegister') : null"
    >
      {{ haveUser ? 'вы зарегистрированы' : 'зарегистрироваться' }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'OlympiadRegister',
  props: {
    material: { type: Object, required: true },
  },
  data: () => ({
    now: new Date(),
    interval: null,
    haveUser: false,
  }),
  computed: {
    startsAt() {
      return this.material?.olympiadPack?.startsAt;
    },
    endsAt() {
      return this.material?.olympiadPack?.endsAt;
    },
    olympiadHasStarted() {
      if (this.startsAt) {
        return this.now > new Date(this.startsAt);
      }
      return true;
    },
    olympiadHasEnded() {
      if (this.endsAt) {
        return +this.now > +new Date(this.endsAt);
      }
      return true;
    },

    countdown() {
      if (!this.startsAt) return {};

      const diff = new Date(this.startsAt) - this.now;
      const days = Math.max(0, Math.floor(diff / 1000 / 60 / 60 / 24));
      const hours = Math.max(0, Math.floor((diff / 1000 / 60 / 60) % 24));
      const minutes = Math.max(0, Math.floor((diff / 1000 / 60) % 60));
      const seconds = Math.max(0, Math.floor((diff / 1000) % 60));

      return {
        days: String(days).padStart(2, '0'),
        daysText: this.getDeclension(days, ['день', 'дня', 'дней']),
        hours: String(hours).padStart(2, '0'),
        hoursText: this.getDeclension(hours, ['час', 'часа', 'часов']),
        minutes: String(minutes).padStart(2, '0'),
        minutesText: this.getDeclension(minutes, ['минута', 'минуты', 'минут']),
        seconds: String(seconds).padStart(2, '0'),
        secondsText: this.getDeclension(seconds, ['секунда', 'секунды', 'секунд']),
      };
    },
  },

  mounted() {
    if (!this.olympiadHasStarted) {
      this.interval = setInterval(this.updateTime, 1000);
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },

  methods: {
    getDeclension(number, words) {
      const cases = [2, 0, 1, 1, 1, 2];
      return words[
        number % 100 > 4 && number % 100 < 20
          ? 2
          : cases[number % 10 < 5 ? number % 10 : 5]
      ];
    },
    updateTime() {
      this.now = new Date();
    },
  },
};
</script>

<style scoped lang="scss">

.olympiad__register {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: calc(var(--scale) * 20);

  @include media-down($size-tablet) {
    height: auto;
    margin-bottom: calc(var(--scale) * 33);
    padding-top: 0;
  }

  @include media-down($size-tablet) {
    margin-bottom: calc(var(--scale) * 40);
    margin-top: calc(-1 * var(--scale) * 16) !important;
  }

  p {
    margin-bottom: calc(var(--scale) * 10);
    font-size: calc(var(--scale) * 20);
    line-height: 130%;
    color: #A7ABAC;

    @include media-down(tablet) {
      margin-bottom: calc(var(--scale) * 5);
      font-size: calc(var(--scale) * 12);
    }
  }

  &--btn {
    width: 100%;
    padding: calc(var(--scale) * 31) calc(var(--scale) * 10) calc(var(--scale) * 34);
    background-color: #FF5319;
    backdrop-filter: blur(5px);
    border-radius: calc(var(--scale) * 24);
    border: none;

    font-weight: 500;
    font-size: calc(var(--scale) * 26);
    line-height: 120%;
    color: #FFFFFF;

    @include media-down($size-tablet) {
      box-shadow:
        calc(var(--scale) * 10) calc(var(--scale) * 10) calc(var(--scale) * 50) rgba(7, 21, 57, 0.1),
        calc(var(--scale) * 4) calc(var(--scale) * 4) calc(var(--scale) * 20) rgba(7, 21, 57, 0.05);
      padding: calc(var(--scale) * 30);
      font-size: calc(var(--scale) * 18);
      line-height: 110%;
      letter-spacing: -0.02em;
    }

    @media (hover: hover) {
      &:hover {
        background-color: #FF9C12;
      }
    }

    &[disabled] {
      pointer-events: none;
      background-color: #ECEDF0;
      color: #A7ABAC;
      box-shadow: none!important;
    }
  }
}

.olympiad__timer {
  display: flex;
  align-items: center;
  gap: calc(var(--scale) * 18);
  margin-bottom: auto;

  @include media-down($size-tablet) {
    margin-bottom: calc(var(--scale) * 20);
    gap: calc(var(--scale) * 12);
  }

  @include media-down($size-mobile) {
    gap: calc(var(--scale) * 21);
  }

  &_item {
    display: grid;

    @include media-down($size-mobile) {
      width: calc(var(--scale) * 60);
      text-align: center;
    }

    p {
      margin-block: calc(-1 * var(--scale) * 9);
      font-weight: 600;
      font-size: calc(var(--scale) * 61);
      line-height: 110%;
      text-align: center;
      letter-spacing: -0.04em;
      color: #7F1A0F;
      font-variant-numeric: tabular-nums;

      @include media-down($size-tablet) {
        font-size: calc(var(--scale) * 42);
        letter-spacing: -0.08em;
        margin-block: calc(-1 * var(--scale) * 6);
      }
    }

    span {
      font-weight: 500;
      font-size: calc(var(--scale) * 19);
      line-height: 120%;
      text-align: center;
      color: rgba(127, 26, 15, 0.3);
      font-variant-numeric: tabular-nums;

      @include media-down($size-tablet) {
        font-size: calc(var(--scale) * 13);
      }
    }
  }

  &_divider {
    width: 1px;
    height: calc(var(--scale) * 43);
    background-color: rgba(127, 26, 15, 0.3);

    @include media-down($size-tablet) {
      height: calc(var(--scale) * 30);
    }
  }
}

</style>
